module.exports = __webpack_public_path__ + "img/convert-bac.0c4fc2aa.png";